import { UseQueryResult, useQuery } from 'react-query'
import request from '../../request'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../store/zustand/dealershipStore'

type ResultType = {
  totalSales: Array<{
    date: string
    sales: number
  }>
  attributedSalesByDate: Array<{
    date: Date
    sales: number
  }>
  salesByMake: Array<{
    make: string
    sales: number
  }>
  salesByModel: Array<{
    model: string
    sales: number
  }>
  salesByState: Array<{
    state: 'New' | 'Used'
    sales: number
  }>
  salesByCampaign: Array<{
    campaign: string
    sales: number
  }>
  salesByDealer: Array<{
    dealer_display_name: string
    polk_dealer_id: number
    dealer_street: string
    dealer_city: string
    attributed_sales: number
    sales: number
  }>
  polkDealers: Array<Record<string, string | number>>
}
export const useGetVerifiedSalesReport = ({
  filters,
}: {
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ResultType, Error>(
    ['inventory', 'polk', dealership?.id, { queryParams }],
    ({ signal }) =>
      request<{ data: ResultType }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/inventory/polk-sales`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }).then((res: { data: ResultType }) => res.data),
  )
}
